import { useRouter } from "vue-router";
import axios from "axios";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "~/shared/constants";
import { useLogout } from "./auth";
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    lang: "",
  },
});
export const useGet = <T>(url: string, query?: { [key: string]: any }) => {
  return api.get<T>(url, { params: query });
};
export const usePost = <T>(url: string, data?: any) => {
  if (data instanceof FormData) {
    return api.post<T>(url, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } else {
    return api.post<T>(url, data);
  }
};

export const usePut = <T>(url: string, data?: any) => {
  return api.put<T>(url, data);
};

export const useDelete = <T>(url: string, data?: any) => {
  return api.delete<T>(url, { data });
};

// Add a request interceptor to attach the access token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// Add a response interceptor to handle token refresh

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      
      useLogout();
    }

    return Promise.reject(error);
  }
);

export default api;
